import React, { Component } from "react";

class LoadingSpinner extends Component {
  render() {
    return (
      <div
        className={[
          "spinner",
          this.props.size ? this.props.size : "spinner-default",
          this.props.isActive && this.props.isActive === true
            ? "is-active"
            : "hidden",
        ].join(" ")}
      >
        <span className="bounce bounce1"></span>
        <span className="bounce bounce2"></span>
        <span className="bounce bounce3"></span>
      </div>
    );
  }
}

export default LoadingSpinner;
